module.exports = __webpack_public_path__ + "static/media/address-icon.eb512e46.svg";